import { container } from 'tsyringe';
import { PusatResolusiV2ApiRepository } from '../../repositories/api/PusatResolusiV2ApiRepository';
import ApiService from '../../services/ApiService';
import { PusatResolusiV2Mapper } from '@/data/persistences/mappers/PusatResolusiV2Mapper';
import { PusatResolusiV2Endpoint } from '../../endpoints/PusatResolusiV2Endpoint';
import { PusatResolusiV2Presenter } from '@/app/ui/presenters/PusatResolusiV2Presenter';

export class PusatResolusiV2Component {
  public static init() {
    container.register<PusatResolusiV2ApiRepository>(PusatResolusiV2ApiRepository, {
      useFactory: d => {
        return new PusatResolusiV2ApiRepository(
          d.resolve(ApiService),
          d.resolve(PusatResolusiV2Mapper),
          d.resolve(PusatResolusiV2Endpoint)
        )
      }
    });
    container.register<PusatResolusiV2Mapper>(PusatResolusiV2Mapper, {
      useClass: PusatResolusiV2Mapper
    });
    container.register<PusatResolusiV2Presenter>(PusatResolusiV2Presenter, {
      useFactory: d => {
        return new PusatResolusiV2Presenter(
          d.resolve(PusatResolusiV2ApiRepository)
        )
      }
    });
  }
}

